import TitleTooltip from "./TitleTooltip";
import Badge from 'rsuite/Badge';
import 'rsuite/Badge/styles/index.css';

export default function Addons({
   complementos
}){

    const newArray = complementos.map((item) => ({ nombre : Object.entries(item)[0][0], cantidad : Object.entries(item)[0][1] }));

    function notiIcon(complementos) {
        switch (complementos){
            case 'WHATS':
                return {
                    icon : <i className={"text-white fs-3 bi bi-whatsapp m-3"}></i>,
                    texto : "Notificación Whatsapp",
                    clase : "WHATS"
                }
            case 'MAIL':
                return {
                    icon : <i className={"text-white fs-3 bi bi-envelope-fill m-3"}></i>,
                    texto : "Notificación MAIL",
                    clase : 'EMAIL'
                }
            case 'MAIL+':
                return {
                    icon : <i className={"text-white fs-3 bi bi-envelope-plus-fill m-3"}></i>,
                    texto : 'Notificación MAIL+',
                    clase : "EMAIL PLUS"
                }
            case 'SMS':
                return {
                icon : <i className={"text-white fs-3 bi bi-chat-left-fill m-3"}></i>,
                texto : "Notificación SMS",
                clase: 'SMS'
            }
            default:
                return {
                    icon : complementos,
                    texto : complementos,
                    clase: `${complementos} fw-bold fs-8`
                }

        }
    }

    return (
        <>
            <style type={'text/css'}>
                {`
                    .rs-badge-wrapper .rs-badge-content{
                        transform : translate(-100%, 100%)!important;
                    }
                    
                    .rs-badge-independent, .rs-badge-content{
                        font-size : .75rem!important;
                    }
                `}
            </style>
            <div className="symbol-group symbol-hover">
                {
                    (newArray && newArray.length > 0) && newArray.map((n, index) => {
                        return <TitleTooltip key={n.nombre} title={notiIcon(n.nombre).texto} placement={'top'}>
                            <div className="symbol symbol-35px symbol-circle">
                            <span className={"symbol-label " + notiIcon(n.nombre).clase}>
                                {
                                    newArray[index].cantidad > 1 ? (
                                        <Badge content={n.cantidad}>
                                            {notiIcon(n.nombre).icon}
                                        </Badge>
                                    ) : (
                                        notiIcon(n.nombre).icon
                                    )
                                }
                            </span>
                            </div>
                        </TitleTooltip>;
                    })
                }
            </div>
        </>
    );
}
